import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import '../../Style/popup.css'
import '../../Style/acordian.css'
import { SERVER_IP, PORT, jwt, auth_response_flow, ud } from '../../Server'
import axios from 'axios';
import TypeForm from './TypeForm'

class TypeHierarchyCAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            heirarchy: [],
            typeHierarchy: [],
            simple: [],
            openCreateParent: false,
            selectedParent: 0,
            iseditmode: false,
            selectednode: {}

        }
    }

    getDataFromType = () => {
        let site_info = sessionStorage.getItem('c_admin_s_typelist');
        if (site_info == "") {
            return
        }

        var data = {
            jwt: jwt,
            s_id: JSON.parse(site_info).id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        var heirarchy = this.state.heirarchy
        axios.post(`${SERVER_IP}/view/types`, data, { withCredentials: true, headers: headers })
            .then(function (response) {

                if (response.data.error === false) {
                    var r = _this.convert(response.data.result.result)
                    _this.setState({ simple: response.data.result.result, typeHierarchy: r })
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getDataFromType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }
    convert = (array) => {
        var map = {};
        for (var i = 0; i < array.length; i++) {
            var obj = array[i];
            obj.children = [];

            map[obj.id] = obj;

            var parent_id = obj.parent_id || '-';
            if (!map[parent_id]) {
                map[parent_id] = {
                    children: []
                };
            }
            map[parent_id].children.push(obj);
        }

        return map['-'].children;

    }
    componentDidMount() {
        this.getDataFromType()
    }
    getInitialState = () => {
        return {
            people: this.state.typeHierarchy
        };
    }
    createParentOpen = () => {
        this.setState({ openCreateParent: true, selectedParent: 0, iseditmode: false })
    }
    selectedNode = (id) => {
        this.setState({ openCreateParent: true, selectedParent: id, iseditmode: false })
    }
    updateTypeForm = () => {
        this.setState({ openCreateParent: false })
        this.getDataFromType()
    }
    editNode = (node) => {
        this.setState({ openCreateParent: true, selectednode: node, iseditmode: true })
    }
    render() {
        var people = this.state.typeHierarchy;
        var nodes = people.length > 0 ? people.map((i) => <TreeNode node={i} children={i.children} selectNode={this.selectedNode} editNode={this.editNode} />) : "No Records Found."

        return (
            <div>
                <div className="xp-breadcrumbbar">
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <h4 className="xp-page-title">All Structures</h4>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <div className="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listsadmin"}>Site List</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="xp-contentbar p-30">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card m-b-30">
                                <div className="card-header dv-center space-between">
                                    {/* <button title="Create New" className="btn btn-primary btn-lg active" onClick={this.createParentOpen}><i className="mdi mdi-plus mr-2"></i>Create New</button> */}
                                </div>
                                <div class="card-body">
                                    {/* {this.state.openCreateParent ?
                                        <div id="popup" class="overlay">
                                            <div class="modal-dialog">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="exampleStandardModalLabel">Types</h5>
                                                        <button type="button" class="close" onClick={() => this.setState({ openCreateParent: false })}>
                                                            <span aria-hidden="true">×</span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <TypeForm updateTypeForm={this.updateTypeForm} parent={this.state.selectedParent} iseditmode={this.state.iseditmode} selectednode={this.state.selectednode} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : null} */}
                                    <ul className="parent-accordian">{nodes}</ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//Tree Structure

class TreeNode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false
        }

        // this.handleClick = this.handleClick.bind(this);
    }
    getInitialState = () => {
        return { isVisible: false };
    }

    toggle = (e) => {
        this.setState({ isVisible: !this.state.isVisible });
    }
    getChild = (prop) => {
  
        prop.selectNode(prop.node.id)
    }
    editChild = (prop) => {
       
        prop.editNode(prop.node)
    }

    render() {
        var icon = this.state.isVisible ? 'fa fa-angle-up' : 'fa fa-angle-down';
        var span;
        var nodes;


        if (this.props.children) {
            span = <span className="icon" onClick={this.toggle}><i className={icon}></i></span>;

            if (this.state.isVisible) {
                nodes = this.props.children.map((i) => <TreeNode node={i} children={i.children} selectNode={this.props.selectNode} editNode={this.props.editNode} />);
            }
        }


        return (
            < li className="accordion-item pc-card mb-2">
                <div className="accordion-title-parent">
                    {span}
                    <div className="bag-icon dv-center">
                        <i className="mdi mdi-briefcase mr-2"></i>
                        {this.props.node.name}
                    </div>

                    {/* <div class="act-btn dv-center">
                        <button className="btn btn-sm btn-info" title="Add" onClick={() => this.editChild(this.props)}>
                            <i className="mdi mdi-pencil"></i>
                        </button>
                        <button className="btn btn-sm btn-secondary mr-2" title="Edit" onClick={() => this.getChild(this.props)}>

                            <i className="mdi mdi-library-plus mr-2"></i>Add
                        </button>

                    </div> */}
                </div>
                <ul className="accordion-content">{nodes}</ul>

            </li >

        );
    }
}

export default TypeHierarchyCAdmin
